import React, { useEffect, useMemo, useState } from 'react';
import MonthSelector from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/components/informationSelect/SimulationMonthSelector';
import YearSelector from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/components/informationSelect/YearSelector';
import {
    extractRawDateMonth,
    extractRawDateYear,
} from 'routes/HumanResourcesModule/Simulation/helpers/dataHelpers';
import {
    HrSimulation,
    SimulationDateString,
} from 'routes/HumanResourcesModule/Simulation/helpers/types';
import Flex from 'ui/Flex/Flex';

type Props = {
    hrSimulation: HrSimulation;
    applicationDate: SimulationDateString;
    setApplicationDate: (date: SimulationDateString) => void;
    restrictMonth?: boolean; // this boolean is used in the month selector to display months included in the simulation range date
};
const ApplicationDateInput = ({
    hrSimulation,
    applicationDate,
    setApplicationDate,
    restrictMonth = false,
}: Props) => {
    const [month, setMonth] = useState<number>(
        extractRawDateMonth(applicationDate),
    );
    const [year, setYear] = useState<number>(
        extractRawDateYear(applicationDate),
    );
    useEffect(() => {
        // to send the date to the format yyyy-mm-dd
        const formattedMonth = month < 10 ? `0${month}` : `${month}`;
        setApplicationDate(
            `${year}-${formattedMonth}-01` as SimulationDateString,
        );
    }, [month, year]);
    const startMonth = useMemo(() => {
        // if restrictMonth is true, we only display months included in the simulation range, else, everything is displayed
        if (restrictMonth) {
            const startDate = new Date(hrSimulation.startDate);
            if (year === startDate.getFullYear()) {
                return startDate.getMonth();
            }
        }
        return 0;
    }, [year]);
    return (
        <Flex
            direction="row"
            sx={{ marginTop: '1em', width: '100%' }}
            justifyContent="space-between"
            gap="10px"
        >
            <MonthSelector
                selectedMonth={month}
                setSelectedMonth={setMonth}
                startMonth={startMonth}
            />
            <YearSelector
                selectedYear={year}
                hrSimulation={hrSimulation}
                setSelectedYear={setYear}
            />
        </Flex>
    );
};

export default ApplicationDateInput;
